import { del, get, patch, post } from '../axios'
import { messageTemplate, MessageTemplateQuery, messageTemplatePurpose } from './message-template'
import { z } from 'zod'
import { paginated } from '../zod/pagination'
import { toQueryString } from '../axios'

export const storeMessageTemplateInput = z.object({
    purpose: messageTemplatePurpose,
    title: z.string(),
    body: z.string(),
    whatsappBusinessAccountId: z.string().optional(),
    public: z.boolean().optional(),
})

export type StoreMessageTemplateInput = z.infer<typeof storeMessageTemplateInput>

export const updateMessageTemplateInput = z.object({
    purpose: messageTemplatePurpose,
    title: z.string(),
    body: z.string(),
    public: z.boolean().optional(),
})

const messageTemplateResponse = z.object({
    message: z.string(),
})

export type UpdateMessageTemplateInput = z.infer<typeof updateMessageTemplateInput>

export function fetchMessageTemplates({ query }: { query?: MessageTemplateQuery } = {}) {
    return get(paginated(messageTemplate), '/message-templates' + `?${toQueryString(query || {})}`)
}

export async function fetchAllMessageTemplates() {
    const response = await fetchMessageTemplates({
        query: {
            size: 100,
            sort: '-created_at',
        },
    })

    return response.data
}

export function storeMessageTemplate(input: StoreMessageTemplateInput) {
    return post(messageTemplate, '/message-templates', input)
}

export function updateMessageTemplate(templateId: string, input: UpdateMessageTemplateInput) {
    return patch(messageTemplate, `/message-templates/${templateId}`, input)
}

export function deleteMessageTemplate(templateId: string) {
    return del(messageTemplateResponse, `/message-templates/${templateId}`)
}
